// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DEVELOPMENTS ||============================== //

const getSearchV2Query = (subData?: Record<string, any>) => {
  const params = new URLSearchParams();
  if (subData?.dcIds) params.set('dc-ids', subData.dcIds);
  if (subData?.agentId) params.set('agent-id', subData.agentId);
  if (subData?.evoost) params.set('evoost', 'true');
  if (subData?.hasinternalcommission) params.set('hasinternalcommission', 'true');
  if (subData?.internalcommissionfirst) params.set('internalcommissionfirst', 'true');
  if (subData?.trialExcl) params.set('trial-excl', 'true');
  if (subData?.code) params.set('code', subData.code);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

const getSearchLocationsV2Query = (action: APIAction) => {
  const params = new URLSearchParams();
  params.set('catalogues', action.data.catalogues);
  if (action?.subData?.dcIds) params.set('dc-ids', action.subData.dcIds);
  if (action?.subData?.evoost) params.set('evoost', 'true');
  if (action?.subData?.hasinternalcommission) params.set('hasinternalcommission', 'true');
  if (action?.subData?.internalcommissionfirst) params.set('internalcommissionfirst', 'true');
  if (action?.subData?.trialExcl) params.set('trial-excl', 'true');
  if (action?.subData?.code) params.set('code', action.subData.code);
  return `?${params.toString()}`;
};

const getSearchMapQuery = (subData?: Record<string, any>) => {
  const params = new URLSearchParams();
  if (subData?.dcIds) params.set('dc-ids', subData.dcIds);
  if (subData?.agentId) params.set('agent-id', subData.agentId);
  if (subData?.evoost) params.set('evoost', 'true');
  if (subData?.hasinternalcommission) params.set('hasinternalcommission', 'true');
  if (subData?.internalcommissionfirst) params.set('internalcommissionfirst', 'true');
  if (subData?.trialExcl) params.set('trial-excl', 'true');
  if (subData?.code) params.set('code', subData.code);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

export async function handleDevelopments(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getList(action.data);
    case 'search':
      // return postRequest('/developments/search', action.data);
      return postRequest(`/developments/search${action.subData.dcIds ? `?dc-ids=${action.subData.dcIds}` : ''}`, action.data);
    case 'search-v2':
      return postRequest(`/developments/search-v2${getSearchV2Query(action.subData)}`, action.data);
    case 'search-map':
      return postRequest(`/developments/search-map${getSearchMapQuery(action.subData)}`, action.data);
    case 'cards-by-ids':
      return postRequest(
        `/developments/cards-by-ids${
          [
            action.subData?.dcIds ? `dc-ids=${action.subData.dcIds}` : '',
            action.subData?.agentId ? `agent-id=${action.subData.agentId}` : '',
            action.subData?.evoost ? `evoost=true` : '',
            action.subData?.hasinternalcommission ? `hasinternalcommission=true` : '',
            action.subData?.internalcommissionfirst ? `internalcommissionfirst=true` : '',
            action.subData?.trialExcl ? `trial-excl=true` : '',
            action.subData?.code ? `code=${encodeURIComponent(action.subData.code)}` : ''
          ].filter(Boolean).length
            ? '?' +
              [
                action.subData?.dcIds ? `dc-ids=${action.subData.dcIds}` : '',
                action.subData?.agentId ? `agent-id=${action.subData.agentId}` : '',
                action.subData?.evoost ? `evoost=true` : '',
                action.subData?.hasinternalcommission ? `hasinternalcommission=true` : '',
                action.subData?.internalcommissionfirst ? `internalcommissionfirst=true` : '',
                action.subData?.trialExcl ? `trial-excl=true` : '',
                action.subData?.code ? `code=${encodeURIComponent(action.subData.code)}` : ''
              ]
                .filter(Boolean)
                .join('&')
            : ''
        }`,
        action.data
      );

    case 'search-special': {
      const params = new URLSearchParams();

      // añade solo si vienen definidos (sin perder un posible "0")
      const setIf = (k: string, v: unknown) => {
        if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
      };

      setIf('dc-ids', action.subData?.dcIds); // ej: "1,2,3"
      setIf('agent-id', action.subData?.agentId); // requerido por backend

      const qs = params.toString(); // ya va url-encoded
      return postRequest(`/developments/search-special${qs ? `?${qs}` : ''}`, action.data);
    }
    case 'search-exclusives':
      return postRequest(
        `/developments/search-exclusives${action.subData.countries ? `?countries=${action.subData.countries}` : ''}`,
        action.data
      );
    case 'search-international':
      return postRequest('/developments/search-international', action.data);
    case 'search-list':
      // return postRequest('/developments/search-list', action.data);
      return postRequest(`/developments/search-list${action.subData.dcIds ? `?dc-ids=${action.subData.dcIds}` : ''}`, action.data);
    case 'search-list-v2':
      return postRequest(
        `/developments/search-list-v2${
          action.subData.dcIds
            ? `?dc-ids=${action.subData.dcIds}&catalogues=${encodeURIComponent(action.data.catalogues)}`
            : `?catalogues=${encodeURIComponent(action.data.catalogues)}`
        }`,
        action.data
      );
    case 'search-list-v3': {
      const params = new URLSearchParams();
      params.set('catalogues', action.data.catalogues);

      if (action?.subData?.dcIds) params.set('dc-ids', action.subData.dcIds);
      if (action?.subData?.agentId) params.set('agent-id', action.subData.agentId);

      return postRequest(`/developments/search-list-v3?${params.toString()}`, action.data);
    }
    case 'search-locations':
      return getRequest('/developments/search-locations');
    case 'search-locations-v2':
      return getRequest(`/developments/search-locations-v2${getSearchLocationsV2Query(action)}`);
    case 'search-locations-02':
      return getRequest('/developments/search-locations-admin');
    case 'permissions':
      // Construir query base
      let query = '';

      if (action.data.trialExclEvoost) {
        // --- MODO trial-excl-evoost ---
        query = `?trial-excl-evoost=true`;

        // Filtro opcional por countries
        if (action.subData?.countries) {
          query += `&countries=${encodeURIComponent(action.subData.countries)}`;
        }

        // Agent id para validar verificación de internal commission
        if (action.data?.agentId) {
          query += `&agent-id=${encodeURIComponent(action.data.agentId)}`;
        }
      } else if (action.data.trialExcl) {
        // --- MODO trial-excl ---
        query = `?catalogues=${encodeURIComponent(action.data.catalogues)}&trial-excl=true`;

        if (action.data?.code) {
          query += `&code=${encodeURIComponent(action.data.code)}`;
        }

        if (action.data?.agentId) {
          query += `&agent-id=${encodeURIComponent(action.data.agentId)}`;
        }

        // Filtro opcional por countries
        if (action.subData?.countries) {
          query += `&countries=${encodeURIComponent(action.subData.countries)}`;
        }
      } else {
        // --- MODO normal ---
        query = `?catalogues=${encodeURIComponent(action.data.catalogues)}`;

        // Filtro opcional por dc-ids
        if (action.data?.dcIds) {
          query += `&dc-ids=${encodeURIComponent(action.data.dcIds)}`;
        }
      }

      // Ejecutar petición
      return getRequest(`/developments/${action.id}/permissions${query}`);
    case 'pack-01':
      return getRequest(`/developments/pack-01-demo`);
    case 'pack-02':
      return getRequest(`/developments/pack-02-demo`);
    case 'create':
      return postRequest('/developments', action.data);
    // case 'read':
    //   return getRequest(`/developments/${action.id}`);
    case 'read': {
      const params = new URLSearchParams();
      if (action.subData?.agentId) params.set('agent-id', action.subData.agentId);

      const qs = params.toString();
      return getRequest(`/developments/${action.id}${qs ? `?${qs}` : ''}`);
    }
    case 'update':
      return putRequest(`/developments/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/developments/${action.id}`);
    case 'read-detail':
      return getRequest(`/developments/${action.id}/detail`);
    case 'read-page-content-v2': {
      const params = new URLSearchParams();
      if (action.data?.language) params.set('language', action.data.language);

      const qs = params.toString();
      return getRequest(`/developments/${action.id}/page-content-v2${qs ? `?${qs}` : ''}`);
    }
    case 'update-detail':
      return putRequest(`/developments/${action.id}/detail`, action.data);
    case 'read-stages':
      return getRequest(`/developments/${action.id}/stages`);
    case 'update-stages':
      return putRequest(`/developments/${action.id}/stages`, action.data);
    case 'read-garages':
      return getRequest(`/developments/${action.id}/garages`);
    case 'update-dropbox':
      return putRequest(`/developments/${action.id}/dropbox`, action.data);
    case 'update-drive':
      return putRequest(`/developments/${action.id}/drive`, action.data);
    case 'update-visibility':
      return putRequest(`/developments/${action.id}/visibility`, action.data);
    case 'update-restrictions':
      return putRequest(`/developments/${action.id}/restrictions`, action.data);
    case 'update-development-company':
      return putRequest(`/developments/${action.id}/development-company`, action.data);
    case 'read-properties':
      return getRequest(`/developments/${action.id}/properties`);
    case 'read-properties-mini':
      return getRequest(`/developments/${action.id}/properties/mini`);
    case 'read-stages-properties':
      return getRequest(`/developments/${action.id}/stages/${action.subData}/properties`);
    case 'read-files':
      return getRequest(`/developments/${action.id}/files`);
    case 'update-page-ai':
      return putRequest(`/developments/${action.subData.developmentId}/page-ai-agent/${action.id}`, action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleDevelopments] - Unknown method');
      break;
  }
}

async function getList(data: any) {
  // let url = `/developments/list?province=${data.province}` + (data.page ? `&page=${data.page}` : data.name ? `&name=${data.name}` : '');
  let url = `/developments/list?province=${data.province}`;
  if (data.hideSold === true) {
    url += `&hideSold=true`;
  } else if (data.hideSold === false) {
    url += `&hideSold=false`;
  }
  if (data.page) url += `&page=${data.page}`;
  if (data.name) url += `&name=${data.name}`;
  return getRequest(url);
}
